import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  title: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#74D588", // rgba(128, 0, 128, 0.50)
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "118px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "30px",
    },
  },
  buttonPRN: {
    height: "50px",
    width: "100px",
    color: "rgba(128, 0, 128, 1)",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "3px solid rgba(128, 0, 128, 1)",
    fontSize: "20px",
    borderRadius: 10,
    fontWeight: "bold",
    gap: "5px",
  },

  detailTitle: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "36px",
    },
    "& button": {
      height: "50px",
      width: "150px",
      color: "#FF0000",
      background: "transparent",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "2px solid #FF0000",
      borderRadius: "25px",
      fontSize: "20px",
      gap: "5px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
  },

  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },

  medicationModal: {
    width: "min(1450px, 98vw)",
    overflowY: "hidden",
    "& .mantine-Paper-root": {
      overflow: "auto !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Modal-header": {
      display: "none",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
  },
  mwd: {
    width: "100%",
  },
  mainContentWarpper: {
    width: "100%",
    height: "70vh",
    maxHeight: "900px",
    overflowY: "auto",
  },
  mainContent: {
    width: "100%",
    // height: "100%",
    padding: "3rem 4rem 5rem 8rem",
    display: "flex",
    "@media (max-width: 700px)": {
      padding: "1.5rem 1rem",
      flexDirection: "column-reverse",
    },
  },
  details: {
    width: "75%",
    "@media (max-width: 700px)": {
      width: "100%",
    },
  },
  personInfo: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    flexDirection: "column",
    width: "25%",
    "@media (max-width: 700px)": {
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "12px",
      marginBottom: "16px",
    },
    "& img": {
      width: "170px",
      height: "160px",
      objectFit: "cover",
      borderRadius: "10px !important",
    },
    "& h3": {
      margin: "0",
      marginTop: "10px",
      textAlign: "center",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25px",
    },
    "& p": {
      margin: "0",
      marginTop: "5px",
      textAlign: "center",
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25px",
    },
  },

  head: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginBottom: "30px",
    "& p": {
      margin: "0",
      fontSize: "32px",
    },
  },
  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "210px",
    height: "100px",
    background: "rgba(128, 0, 128, 0.15)",
    "& h3": {
      margin: "0",
      fontSize: "36px",
      textTransform: "capitalize",
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "16px !important",
    },
  },
  span1: {
    fontWeight: "600",
    fontSize: "36px",
  },
  span3: {
    color: "var(--app-text-muted)",
    margin: "0",
  },

  outcome: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  redText: {
    color: "#FF0000",
  },
  dispensed: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      fontWeight: "400",
      fontSize: "36px",
      margin: "0",
      marginBottom: "10px",
    },
  },
  quantity: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      margin: "0",
      fontSize: "85px",
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "20px ",
    },
  },
  radioContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    "& .mantine-1svz3tp": {
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "24px",
      fontWeight: "800",
      lineHeight: "25px",
    },
    "& .mantine-1cu6yj8:checked": {
      background: "var(--app-primary)",
      borderColor: "var(--app-primary)",
    },
  },
  wasEffectiveRadioContainer: {
    width: "50%",
    "@media (max-width: 700px)": {
      width: "100%",
    },
  },
  effectiveContainer: {
    display: "flex",
    alignItems: "center",
    padding: "3rem 4rem 5rem 8rem",
    "@media (max-width: 700px)": {
      padding: "1rem 1rem 2rem 1rem",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "16px",
    },
    "& button": {
      color: "var(--app-text)",
      background: "rgba(128, 0, 128, 0.25)",
      fontSize: 20,
    },
    "& button:hover": {
      background: "rgba(128, 0, 128, 0.25)",
      // background:""
    },
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    borderBottom: "3px solid var(--app-border)",
    background: "var(--app-surface-2)",
    marginTop: "20px",
    gap: "20px",
    paddingInline: "30px",
    paddingBlock: "10px",
    "@media (max-width: 700px)": {
      paddingInline: "12px",
    },
    "& .column1": {
      flex: 1,
      "& p": {
        textAlign: "left",
      },
      "& h3": {
        textAlign: "left",
      },
    },
    "& .column2": {
      "& h3": {
        color: "var(--app-text)",
        fontStyle: "normal",
        fontWeight: 300,
        lineHeight: "25px",
        paddingLeft: "20px",
      },
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25px",
      marginBottom: "20px",
    },
    "& h3": {
      margin: "0",
      textAlign: "center",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25px",
    },
  },
  comments: {
    "& .mantine-1ix1d88": {
      borderRadius: "15px",
    },
  },

  upcomingHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#bf80bf",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "118px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "30px",
    },
  },

  quantityInput: {
    "& input": {
      borderRadius: "5px",
      width: "100%",
      maxWidth: "160px",
      height: "100px",
      border: "1px solid var(--app-border)",
      fontSize: "60px",
      fontWeight: "bold",
      textAlign: "center",
    },
  },
  medicationBox: {
    marginBottom: "20px",
  },
  saveButton: {
    marginTop: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      borderRadius: "5px",
      background: "var(--app-primary)",
      width: "145px",
      height: "60px",
      color: "var(--app-on-primary)",

      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "var(--app-primary)",
      },
    },
  },
  updateButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& img": {
      width: "25px",
      height: "25px",
      marginRight: "2px",
    },
    "& button": {
      borderRadius: "5px",
      background: "var(--app-primary)",
      width: "auto",
      height: "40px",
      color: "var(--app-on-primary)",

      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "var(--app-primary)",
      },
    },
  },
  editButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "transparent",
      width: "auto",
      height: "auto",
      color: "var(--app-primary)",

      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        color: "var(--app-primary)",
        background: "transparent",
      },
    },
  },
  prnSelectBox: {
    "& .mantine-Select-input": {
      background: "var(--app-surface-2)",
      borderRadius: 15,
      minHeight: "1rem !important",
      height: "4rem !important",
    },
  },
  editButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "transparent",
      width: "auto",
      height: "auto",
      color: "var(--app-primary)",

      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        color: "var(--app-primary)",
        background: "transparent",
      },
    },
  },

  // ── DRAWER STYLES ────────────────────────────────────────────────────
  drawerBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  modalTopBar: {
    width: "100%",
    height: "64px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 24px",
    borderBottom: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    borderRadius: "16px 16px 0 0",
  },
  modalTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 700,
    color: "var(--app-text)",
    fontFamily: "Inter",
  },
  modalCloseBtn: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "var(--app-text-muted)",
    lineHeight: 1,
    padding: "4px 8px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  formBox: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    backgroundColor: "var(--app-surface-2)",
  },
  prnWrapper: {
    width: "100%",
    padding: "24px 20px",
  },
  // ── FIELD STYLES ─────────────────────────────────────────────────────
  inputStyle: {
    marginBottom: "12px",
    "& .mantine-Input-wrapper": {
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        color: "var(--app-text)",
      },
      "& .mantine-Textarea-input": {
        height: "auto",
        overflowY: "auto",
        padding: "10px 14px",
      },
      "& .mantine-TimeInput-input, & .mantine-DateInput-input": {
        paddingLeft: 36,
      },
      "& .mantine-Select-rightSection svg, .mantine-MultiSelect-rightSection svg":
        {
          color: "var(--app-text-muted)",
        },
    },
    "& .mantine-DatePickerInput-wrapper": {
      "& .mantine-DatePickerInput-icon": {
        "& svg": {
          color: "var(--app-text)",
          fontSize: 18,
        },
      },
      "& .mantine-DatePickerInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-TimeInput-wrapper": {
      "& .mantine-TimeInput-icon": {
        "& svg": {
          color: "var(--app-text)",
          fontSize: 18,
        },
      },
      "& .mantine-TimeInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  medicineCard: {
    background: "var(--app-surface-2)",
    borderRadius: 16,
    border: "1px solid var(--app-border)",
    padding: "15px 13px",
    marginBottom: "16px",
  },
  accordionSelectItem: {
    borderRadius: "12px !important",
    background: "var(--app-surface-2) !important",
    border: "none !important",
    boxShadow: "none !important",
    overflow: "hidden",
    marginBottom: "0 !important",
    "&[data-active]": {
      background: "var(--app-surface-2) !important",
    },
  },
  accordionSelectControl: {
    fontSize: "14px",
    fontFamily: "Inter",
    color: "var(--app-text)",
    fontWeight: 500,
    minHeight: "48px !important",
    padding: "0 16px !important",
    background: "transparent !important",
    "& .mantine-Accordion-chevron": {
      color: "var(--app-text)",
    },
  },
  effectiveRadioPanel: {
    background: "var(--app-surface)",
    borderRadius: 8,
    border: "1px solid var(--app-border)",
    padding: "14px 16px",
    margin: "0 0 12px 0",
  },
  quantityRow: {
    alignItems: "center",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    overflow: "hidden",
    background: "var(--app-surface-2)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    paddingInline: "13px",
  },
  qtyBtn: {
    width: "26px !important",
    minWidth: "26px",
    height: "26px !important",
    minHeight: "26px",
    borderRadius: "50% !important",
    background: "var(--app-surface) !important",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
    border: "none !important",
    color: "var(--app-text)",
    "&:hover": {
      background: "var(--app-surface-2) !important",
    },
  },
  qtyInput: {
    flex: 1,
    height: "44px",
    border: "none",
    outline: "none",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Inter",
    color: "var(--app-text)",
    background: "transparent",
    padding: "0 8px",
    width: "100%",
    MozAppearance: "textfield",
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
  prnSaveBtn: {
    padding: "10px 22px",
    borderRadius: 8,
    border: "1px solid var(--app-primary)",
    background: "var(--app-primary)",
    color: "var(--app-on-primary)",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    cursor: "pointer",
    boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
    transition: "background .12s ease",
    "&:disabled": {
      border: "1px solid var(--app-border)",
      background: "var(--app-surface-2)",
      color: "var(--app-text-muted)",
      cursor: "not-allowed",
      boxShadow: "none",
    },
  },

  prnCancelBtn: {
    padding: "10px 22px",
    background: "transparent",
    border: "transparent",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    cursor: "pointer",
  },
  medicineInnerCard: {
    padding: "8px 12px",
    background: "var(--app-surface)",
    borderRadius: 8,
    border: "1px solid var(--app-border)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  datetimeInput: {
    "& .mantine-Input-wrapper": {
      "& .mantine-Input-input": {
        padding: "10px 14px 10px 36px",
      },
      "& .mantine-TextInput-icon svg": {
        color: "var(--app-text)",
      },
    },
  },

  // ── VIEW DRAWER STYLES ────────────────────────────────────────────
  modalBackBtn: {
    background: "none",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "var(--app-text-muted)",
    lineHeight: 1,
    padding: "6px 8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontFamily: "Inter",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  viewClientCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "var(--app-surface)",
    borderRadius: 12,
    border: "1px solid var(--app-border)",
    padding: "12px 16px",
    marginBottom: 16,
  },
  clientAvatar: {
    width: 44,
    height: 44,
    borderRadius: 8,
    objectFit: "cover",
  },
  clientName: {
    fontSize: "14px !important",
    fontWeight: "600 !important",
    color: "var(--app-text) !important",
    fontFamily: "Inter",
  },
  clientId: {
    fontSize: "12px !important",
    color: "var(--app-text-muted) !important",
    fontFamily: "Inter",
  },
  prnBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 12px",
    borderRadius: 16,
    backgroundColor: "var(--app-tint-purple)",
    color: "#6941C6",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  unlimitedBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 12px",
    borderRadius: 16,
    background: "var(--app-surface-2)",
    color: "var(--app-text)",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  narcoticBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px 8px",
    borderRadius: 6,
    background: "var(--app-tint-amber)",
    border: "1px solid #FFB74D",
    color: "#E65100",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "Inter",
  },
  medDetailsCard: {
    background: "var(--app-surface-2)",
    borderRadius: 12,
    border: "1px solid var(--app-border)",
    padding: "14px 16px",
    marginBottom: 16,
  },
  medDetailsTitle: {
    fontSize: "15px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    margin: 0,
  },
  editBtnOrange: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "8px",
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "600",
    height: "40px !important",
    padding: "0 16px !important",
    border: "none !important",
    "&:hover": { backgroundColor: "var(--app-primary)", opacity: 0.8 },
  },
  cancelBtn: {
    backgroundColor: "var(--app-surface-2)",
    color: "var(--app-text)",
    border: "1px solid var(--app-border) !important",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    height: "40px",
    fontFamily: "Inter",
    padding: "0 16px !important",
    "&:hover": { backgroundColor: "var(--app-surface-2)", opacity: 0.8 },
  },
  editBtnSmall: {
    color: "var(--app-primary) !important",
    fontSize: "13px !important",
    fontWeight: "600 !important",
    "&:hover": {
      background: "rgba(251, 170, 13, 0.08) !important",
    },
  },
  medDetailsInner: {
    background: "var(--app-surface)",
    borderRadius: 10,
    border: "1px solid var(--app-border)",
    padding: "12px 16px",
    width: "100%",
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
  },
  medDetailsCol: {
    flex: 1,
    minWidth: 80,
  },
  medDetailsLabel: {
    fontSize: "12px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    margin: "0 0 6px 0",
  },
  medDetailsValue: {
    fontSize: "13px",
    fontWeight: 600,
    color: "var(--app-text)",
    fontFamily: "Inter",
    margin: 0,
  },
  medDetailsSigImg: {
    height: 36,
    maxWidth: "100%",
    objectFit: "contain",
  },
  medDetailsSigText: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: "Island Moments",
    color: "var(--app-text)",
    lineHeight: "normal",
    margin: 0,
  },
  editDetailsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    width: "100%",
  },
  sigBox: {
    background: "var(--app-surface-2)",
    minHeight: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
  },
  timeInputLeftIcon: {
    pointerEvents: "all",
    cursor: "pointer",
  },
  medicineDetailsCard: {
    background: "var(--app-surface-2)",
    borderRadius: 8,
    border: "1px solid var(--app-border)",
    padding: 8,
    marginBottom: "16px",
  },
  medFreqAndCountRow: {
    alignItems: "center",
    justifyContent: "space-between",
    paddingBlock: 7,
    borderBottom: "1px solid var(--app-border)",
    "& .freqAndTime": {
      "& .frequency": {
        fontSize: "16px",
        fontWeight: 600,
        color: "var(--app-text)",
        fontFamily: "Inter",
        margin: 0,
      },
      "& .time": {
        fontSize: "10px",
        fontWeight: 400,
        color: "var(--app-text-muted)",
        fontFamily: "Inter",
        margin: 0,
      },
    },
  },
  remainingText: {
    fontSize: "12px",
    color: "var(--app-text)",
    fontFamily: "Inter",
    margin: 0,
  },
  quantityAndInfoRow: {
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlock: 12,
    paddingBottom: 12,
    "& .name": {
      fontSize: "14px",
      fontWeight: 600,
      color: "var(--app-text)",
      fontFamily: "Inter",
      margin: 0,
    },
    "& .dosage": {
      fontSize: "10px",
      fontWeight: 400,
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      margin: 0,
    },
  },
  viewQtyNumber: {
    fontSize: "16px",
    fontWeight: 600,
    color: "var(--app-text)",
    fontFamily: "Inter",
    margin: 0,
  },
  viewQtyLabel: {
    fontSize: "10px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    margin: 0,
  },
  viewInfoBox: {
    backgroundColor: "var(--app-surface-2)",
    borderRadius: 8,
    padding: "10px 12px",
    marginBottom: 12,
  },
  viewInfoRow: {
    justifyContent: "space-between",
    gap: 12,
  },
  viewInfoLabel: {
    fontSize: "11px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    margin: "0 0 4px 0",
  },
  viewInfoValue: {
    fontSize: "13px",
    fontWeight: 600,
    color: "var(--app-text)",
    fontFamily: "Inter",
    margin: 0,
  },
  reasonSection: {
    marginTop: 4,
  },
  reasonLabel: {
    fontSize: "11px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    margin: "0 0 4px 0",
  },
  reasonValue: {
    fontSize: "12px",
    fontWeight: 700,
    color: "var(--app-text)",
    fontFamily: "Inter",
    margin: 0,
  },
  labelStyle: {
    color: "var(--app-text)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    margin: 0,
    marginBottom: "6px",
  },

  // ── NEW-PRN DRAWER ────────────────────────────────────────────────────
  prnSubtitle: {
    margin: "2px 0 0",
    fontSize: 12,
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
  },
  prnFooter: {
    padding: "14px 22px",
    borderTop: "1px solid var(--app-border)",
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    background: "var(--app-surface)",
    borderRadius: "0 0 16px 16px",
    flexShrink: 0,
  },
  prnRadioCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    border: "1px solid var(--app-border)",
    borderRadius: 8,
    background: "var(--app-surface)",
    cursor: "pointer",
    transition: "background .12s ease",
    "&:hover": {
      background: "var(--app-surface-2)",
    },
  },
  prnSelectedCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    border: "1px solid var(--app-primary)",
    borderRadius: 8,
    background: "var(--app-tint-amber)",
    marginBottom: 8,
  },

  prnQtyStaffRow: {
    display: "flex",
    gap: 12,
    marginBottom: 12,
  },
  prnMedInfoRow: {
    marginTop: 8,
    padding: "12px 14px",
    border: "1px solid var(--app-border)",
    borderRadius: 8,
    background: "var(--app-surface)",
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    marginBottom: 16,
  },
  prnEmptyState: {
    padding: 24,
    textAlign: "center",
    color: "var(--app-text-muted)",
    fontSize: 13,
    fontFamily: "Inter",
    background: "var(--app-surface-2)",
    borderRadius: 8,
    border: "1px dashed var(--app-border)",
  },
  pillIconWrap: {
    width: 34,
    height: 34,
    borderRadius: 8,
    background: "var(--app-tint-amber)",
    border: "1px solid #FFE4A8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#92400E",
  },
  pillIconWrapNarcotic: {
    width: 34,
    height: 34,
    borderRadius: 8,
    background: "var(--app-tint-red)",
    border: "1px solid #FECACA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#B91C1C",
  },
}));

export default useStyles;
